<template>
  <div class="m-content" id="userInfo">
    <p class="info-text">请先填写以下个人信息</p>
    <el-form
    	ref="userInfo"
      :rules="rules"
    	:model="form"
    	@keydown.enter.native="submit"
    >
      <el-form-item prop="name">
        <label class="form-label">1.您的姓名：<span>*</span></label>
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item prop="gender">
        <label class="form-label">2.您的性别：<span>*</span></label>
        <el-select v-model="form.gender" placeholder="" style="width:100%">
          <el-option value="男">男</el-option>
          <el-option value="女">女</el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="studentUniversity">
        <label class="form-label">3.您的学校：<span>*</span></label>
        <el-select v-model="form.studentUniversity" placeholder="" @change="findCollege" style="width:100%">
          <el-option v-for="(item,index) in universities" :value="item">{{item}}</el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="studentCollege">
        <label class="form-label">4.您的学院：<span>*</span></label>
        <el-select v-model="form.studentCollege" placeholder="" @change="findMajor" style="width:100%">
          <el-option v-for="(item,index) in colleges" :value="item">{{item}}</el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="studentMajor">
        <label class="form-label">5.您的专业大类/专业/班级：<span>*</span></label>
        <el-select v-model="form.studentMajor" placeholder="" style="width:100%">
          <el-option v-for="(item,index) in major" :value="item">{{item}}</el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="studentDegree">
        <label class="form-label">6.您的年级：<span>*</span></label>
        <el-select v-model="form.studentDegree" placeholder="" style="width:100%">
          <el-option value="">请选择</el-option>
          <el-option v-for="item in degrees" :key="item.value" :label="item.name" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="studentNo">
        <label class="form-label">7.您的学号：</label>
        <el-input v-model="form.studentNo"></el-input>
      </el-form-item>
      <el-form-item prop="campusName">
        <label class="form-label">8.您的校区：<span>*</span></label>
        <el-select v-model="form.campusName" placeholder="" style="width:100%">
          <el-option v-for="(item,index) in operators" :value="item.campusName">{{item.campusName}}</el-option>
        </el-select>
      </el-form-item>             
      <el-button
        v-if="shengyaUser.operator && shengyaUser.studentCollege && shengyaUser.operator.admin.manageAccCode==shengyaUser.admin.manageAccCode"
      	type="info"
      	@click="cancelEdit"
      	class="btn-success"
      	style="width:100%; margin-top: 6px;"
        v-show="btnVisible"
      >返回</el-button>
      <el-button
      	type="success"
      	@click="saveUser"
      	class="btn-success"
      	style="width:100%; margin-top:10px;margin-left:0;"
        v-preventReClick
      >提交</el-button>
    </el-form>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Form, FormItem, Select, Option,Input, Radio, RadioGroup } from 'element-ui'
import axios from 'axios';
import qs from 'qs';
export default {
  name: 'Info',
  components: {
    ElForm: Form,
    ElFormItem: FormItem,
    ElInput: Input,
    ElSelect: Select,
    ElOption: Option,
    ElRadio: Radio,
    ElRadioGroup: RadioGroup,
  },
  data () {
    return {
      form: {
        name:'',
        gender:'',
        studentUniversity:'',
        studentCollege:'',
        studentDegree:'',
        studentMajor:'',
        studentNo:'',
        campusName:'',
      },
      rules: {
        name: [{ required: true, message: '请输入昵称', trigger: 'blur' }],
        gender: [{ required: true, message: '请选择性别', trigger: 'change' }],
        studentUniversity:[{ required: true, message: '请选择学校', trigger: 'change' }],
        studentCollege:[{ required: true, message: '请选择学院', trigger: 'change' }],
        studentMajor:[{ required: true, message: '请选择专业', trigger: 'change' }],
        studentDegree:[{ required: true, message: '请选择年级', trigger: 'change' }],
        campusName:[{ required: true, message: '请选择校区', trigger: 'change' }],        
      },
      universities:[],
      colleges:[],
      major:[],
      operators:[],
      allDegrees: [
        {"value":"专科一年级","name":"专科一年级"},
        {"value":"专科二年级","name":"专科二年级"},
        {"value":"专科三年级","name":"专科三年级"},
        {"value":"本科一年级","name":"本科一年级"},
        {"value":"本科二年级","name":"本科二年级"},
        {"value":"本科三年级","name":"本科三年级"},
        {"value":"本科四年级","name":"本科四年级"},       
        {"value":"硕士一年级","name":"硕士一年级"},  
        {"value":"硕士二年级","name":"硕士二年级"},  
        {"value":"硕士三年级","name":"硕士三年级"},  
        {"value":"博士","name":"博士"},  
        {"value":"其他","name":"其他"},                                     
      ],
      btnVisible:false
    }
  },
  computed:{
    ...mapState({
      shengyaUser: state => state.shengyaUser.userInfo,
    }),
    jsonSetting() {
      return JSON.parse(this.shengyaUser.admin.jsonSetting);
    },    
    degrees(){
      let degrees=[];
      if(this.jsonSetting && this.jsonSetting.degree=='本科'){
        degrees = [
          {"value":"本科一年级","name":"本科一年级"},
          {"value":"本科二年级","name":"本科二年级"},
          {"value":"本科三年级","name":"本科三年级"},
          {"value":"本科四年级","name":"本科四年级"},       
          {"value":"硕士一年级","name":"硕士一年级"},  
          {"value":"硕士二年级","name":"硕士二年级"},  
          {"value":"硕士三年级","name":"硕士三年级"},  
          {"value":"博士","name":"博士"},  
          {"value":"其他","name":"其他"},            
        ];
      }
      else if(this.jsonSetting && this.jsonSetting.degree=='专科科'){
        degrees = [
          {"value":"专科一年级","name":"专科一年级"},
          {"value":"专科二年级","name":"专科二年级"},
          {"value":"专科三年级","name":"专科三年级"},       
        ];
      }
      else{
        degrees = this.allDegrees;
      }
      return degrees;
    },
  },
  created(){
     this.universities.push(this.shengyaUser.studentUniversity) ;
     this.getUserInfo();
  },
  methods:{
    saveUser() {
      this.$refs['userInfo'].validate(valid => {
        if (valid) {
          this.submit()
        }
      })
    },
    submit(){
      let data =this.getInfo();
      console.log(data);
      const options = {
        method: 'post',
        headers: { 'content-type': 'application/x-www-form-urlencoded'},
        data:qs.stringify({
          submitdata: data,
          openId: this.shengyaUser.openid
        }),
        url:'/cob/saveCosUser.do'
      }
      axios(options)
      .then( (res) => {
        res = res.data
        // console.log(res.data);
        if (res.result.success) {
          var  shengyaUser = res.data
          store.dispatch('setUserInfo', shengyaUser)
          this.$emit('finish-user')
        }
        else{
          this.$store.commit('showMessage', {
            message: '保存失败：',
            type: 'error'
          })
        }
      })
    },
    cancelEdit(){
      this.$emit('return-activities')
    },
    getInfo(){
      let data='';
      data+='10$'+this.form.name+'}';
      data+='20$'+this.form.gender+'}';
      data+='30$'+this.form.studentUniversity+'}';
      data+='40$'+this.form.studentCollege+'}';
      data+='50$'+this.form.studentMajor+'}';
      data+='60$'+this.form.studentDegree+'}';
      data+='70$'+this.form.studentNo+'}';
      data+='80$'+this.form.campusName;
      return data;
    },
    findCollege(){
      const _this = this;
      const options = {
        method: 'POST',
        headers: { 'content-type': 'application/x-www-form-urlencoded'},
        data:qs.stringify({
          univName :_this.form.studentUniversity,
          openId: this.shengyaUser.openid
        }),
        url:'/cob/findCollege.do'
      }
      axios(options)
        .then((res) => {
          _this.colleges =res.data;
          })
          .catch(function (error) {
          console.log(error);
        })
    },
    findMajor(){
      const _this = this;
      const options = {
        method: 'POST',
        headers: { 'content-type': 'application/x-www-form-urlencoded'},
        data:qs.stringify({
          univName:_this.form.studentUniversity,
          collegeName:_this.form.studentCollege,
          openId: this.shengyaUser.openid,
        }),
        url:'/cob/findMajor.do'
      }
      axios(options)
        .then((res) => {
          _this.major = res.data;
          })
          .catch(function (error) {
          console.log(error);
        })
    },
    findOperators(){
      const _this = this;
      const options = {
        method: 'POST',
        data:qs.stringify({
          adminCode: this.shengyaUser.admin.manageAccCode,
        }),
        url:'/cob/findOperators.do'
      }
      axios(options)
        .then((res) => {
            res = res.data
            if (res.result.success) {
              _this.operators = res.data;
            }
          })
          .catch(function (error) {
            console.log(error);
        })
    },    
    getUserInfo(){
        if(this.shengyaUser.studentUniversity){
          this.btnVisible = true;
          this.form.studentUniversity = this.shengyaUser.studentUniversity
          this.form.name = this.shengyaUser.studentName
          this.form.gender = this.shengyaUser.studentSex
          this.form.studentDegree = this.shengyaUser.studentDegree
          this.form.studentNo = this.shengyaUser.studentNo
          //学院
          this.findCollege()
          this.form.studentCollege = this.shengyaUser.studentCollege
          //专业
          this.findMajor()
          this.form.studentMajor = this.shengyaUser.studentMajor
          //校区
          this.findOperators();
          if(this.shengyaUser.operator && this.shengyaUser.operator.admin.manageAccCode==this.shengyaUser.admin.manageAccCode)
            this.form.campusName = this.shengyaUser.operator.campusName
        }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .m-content
    form
      border-top:1px solid #d5d5d5
      margin:0.4rem
  .info-text
    font-size: 0.32rem
    padding: 0.2rem 0.4rem 0 0.4rem
  .form-label
    display: block
    font-weight: bold
    span
      color:#E13716
      font-weight:bold
      font-size: 0.36rem
  .el-radio-group
    .el-radio
      margin-right:0
      background-color :#FFFFFF
      padding:0.2rem 3rem 0.2rem 0.2rem
      border:1px solid #d5d5d5
</style>
